import React, { useEffect, useState } from "react";
import "./style.css";
import useFetchProfile from "../../hooks/useFetchProfile";
import OrgLogoPNG from "../../assets/images/org-logo.png";
import defaultIMG from "../../assets/images/default.png"
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function ProfilePage() {


  const [profile, loading] = useFetchProfile();

  const [profileImage, setProfileImage] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [image, setImage] = useState(defaultIMG);
  const [isOrganization, setIsOrganization] = useState(false);
  const [organizationName, setOrganizationName] = useState("");
  const [organizerName, setOrganizerName] = useState("");
  const [orgEmail, setOrgEmail] = useState("");
  const [orgMobile, setOrgMobile] = useState("");
  const [organizationLogo, setOrganizationLogo] = useState(defaultIMG);
  const { auth, setCommonError, setCommonWarning, setCommonSuccess } =
    useAuth();
  const navigate = useNavigate();
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    if (profile.length > 0) {
      const user = profile[0];
      setName(user.name || "");
      setEmail(user.email || "");
      setImage(user.image || "");
      setIsOrganization(user.is_organization || false);
      setOrganizationName(user.organization_name || "");
      setOrganizerName(user.organizer_name || "");
      setOrgEmail(user.org_email || "");
      setOrgMobile(user.org_mobile || "");
      setOrganizationLogo(user.organization_logo || "");
    }
  }, [profile]);

  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const imageURL = URL.createObjectURL(file);
      // console.log("Preview URL:", imageURL);
      setProfileImage(imageURL);
      setImageFile(file);
    }
  };

  const handleUpdate = () => {
    alert("Profile updated successfully!");
  };

  const formSubmit = async (e) => {
    e.preventDefault();

    try {
      // console.log(name, email, imageFile);
      const formData = new FormData();
      formData.append("token", auth.token);
      formData.append("name", name);
      formData.append("email", email);
      if (imageFile) {
        formData.append("profile_image", imageFile);
      }
      // for (let [key, value] of formData.entries()) {
      //   console.log(key, value);
      // }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}update-profile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === 200) {
        setCommonSuccess("Profile updated successfully!");
      } else if (response.data.status === 401) {
        navigate("/login");
      } else if (response.data.status === 400) {
        setCommonWarning(response.data.message || "Error updating profile");
      } else {
        setCommonError(response.data.message || "Error updating profile");
      }
    } catch (err) {
      console.error("Submit error:", err);
      setCommonError("Submit error:", err);
    }
  };

  return (
    <div className="profile-content-box">
      <div className="profile-container">
        <form onSubmit={formSubmit}>
          <div className="profile-card">
            <div className="profile-header">
              <div className="avatar-wrapper">
                <img
                  src={profileImage || image || OrgLogoPNG}
                  alt="Profile"
                  className="pf-avatar"
                />

                <input
                  type="file"
                  accept="image/*"
                  id="upload"
                  style={{ display: "none" }}
                  onChange={handleImageUpload}
                />

                <button
                  type="button"
                  className="camera-button"
                  onClick={() => document.getElementById("upload").click()}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                  >
                    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                    <circle cx="12" cy="13" r="4"></circle>
                  </svg>
                </button>
              </div>
            </div>

            <div className="profile-form">
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="profile-input"
                placeholder="Name"
                name="name"
              />

              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="profile-input"
                placeholder="Email"
                name="email"
              />

              <button className="update-button" type="submit">
                Update Profile
              </button>
            </div>
          </div>
        </form>
      </div>
      {isOrganization && (
        <div className="org-container">
          <div className="org-card">
            <div className="org-logo">
              <img src={organizationLogo} alt="Organization Logo" />
            </div>
            <div className="org-details">
              <h2>Organization Details</h2>
              <div className="org-info">
                <p>
                  <strong>Organization Name: </strong> {organizationName}
                </p>
                <p>
                  <strong>Organizer Name: </strong> {organizerName}
                </p>
                <p>
                  <strong>Email: </strong> {orgEmail}
                </p>
                <p>
                  <strong>Mobile: </strong> {orgMobile}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProfilePage;
